var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.95 25.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#ffab02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 25.95,
    height: 25.95,
    rx: 5.38,
    ry: 5.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "email-solid-badged"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139621",
    className: "cls-1",
    d: "m15.99,10.8c-.87-.55-1.4-1.51-1.4-2.54h-7.45c-.07,0-.14.01-.21.03l5.79,5.77,3.27-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139622",
    className: "cls-1",
    d: "m17.6,11.27c-.27,0-.54-.04-.8-.12l-3.49,3.48c-.31.31-.82.31-1.13,0l-5.8-5.77c-.02.07-.03.13-.03.2v8.02c0,.44.36.8.8.8h11.22c.44,0,.8-.36.8-.8v-6.26c-.47.29-1.02.45-1.58.44Zm-9.9,5.81h-.56v-.57l2.91-2.89.57.57-2.92,2.9Zm10.67,0h-.56l-2.92-2.9.57-.57,2.91,2.89v.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139623",
    className: "cls-1",
    d: "m19.6,8.26c0,1.11-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact1);
export default __webpack_public_path__ + "static/media/contact1.849e939bb0b244fe50f0a6aa58050565.svg";
export { ForwardRef as ReactComponent };